import { readHqRule } from "../lib/hq-rule";

const HQ_BADGE_HINT = "HQ-Regel aktiv: passende Eintragungen erzeugen zusätzlich ein HQ-Lead.";
const META_ONLY_HINT =
  "Von dieser Quelle gehen normale Leads nicht an Meta; HQ-Leads gehen als Lead, wenn Lead in der Meldungs-Tabelle angehakt ist.";

/**
 * Small "HQ" pill in the data-source list; only for a switched-on, readable HQ rule (TASK-247).
 * TASK-253: with the Meta switch on, a second pill "nur HQ an Meta" follows.
 */
export function HqBadge({ mapping }: { mapping: { hq_rule?: unknown } | null }) {
  const rule = readHqRule(mapping?.hq_rule);
  if (rule?.enabled !== true) return null;
  return (
    <>
      <span
        data-testid="hq-badge"
        title={HQ_BADGE_HINT}
        className="rounded-full bg-accent-subtle px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wider text-accent-text"
      >
        HQ
        <span className="sr-only">{HQ_BADGE_HINT}</span>
      </span>
      {rule.meta_hq_only === true && (
        <span
          data-testid="hq-badge-meta"
          title={META_ONLY_HINT}
          className="rounded-full bg-bg-tertiary px-1.5 py-0.5 text-[9px] font-medium tracking-wide text-text-secondary"
        >
          nur HQ an Meta
          <span className="sr-only">{META_ONLY_HINT}</span>
        </span>
      )}
    </>
  );
}
